import { Typography } from '@common/styles';

import { InfoIcon } from '../assets/InfoIcon';
import { MyFigure } from '../components/MyFigure';
import { OthersSize } from '../components/OthersSize';
import { OthersSizeOption } from '../components/OthersSizeOption';
import { OthersSizeOptionList } from '../components/OthersSizeOptionList';
import { RecommendTooltip } from '../components/RecommendTooltip';
import { useLegacyOthersSizeService } from '../services/useLegacyOthersSizeService';

export const LegacyOthersSizeContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { userAccount, handleInfoClick, recommendOptionValueList, infoOpen, closeTooltip, isOptionType } =
    useLegacyOthersSizeService();

  return (
    <>
      <OthersSize.Title className={Typography.BODY_17_SEMIBOLD}>사이즈 추천</OthersSize.Title>
      <OthersSize.Subtitle className={Typography.BODY_14_REGULAR}>
        내 체형(<MyFigure userAccount={userAccount} />) 구매 정보가 없어요.
      </OthersSize.Subtitle>
      <OthersSize.List>
        <OthersSize.ListHeader className={Typography.BODY_15_SEMIBOLD}>
          다른 체형이 구매했어요
          <OthersSize.TooltipTrigger aria-label='사이즈 추천 안내 버튼' onClick={handleInfoClick}>
            <InfoIcon />
          </OthersSize.TooltipTrigger>
        </OthersSize.ListHeader>
        <OthersSizeOptionList
          items={recommendOptionValueList}
          renderItem={(item, index) => (
            <OthersSizeOption
              key={item.name + index}
              name={item.name}
              heightRange={item.heightRange}
              weightRange={item.weightRange}
            />
          )}
        />
      </OthersSize.List>
      <RecommendTooltip open={infoOpen} onClose={closeTooltip} isOptionType={isOptionType} />
    </>
  );
};
